import State from 'interfaces/state/State';

export const currentTrack$ = (state: State) => state.sharedPlayer.currentTrack;
export const isLoading$ = (state: State) => state.sharedPlayer.isLoading;
export const isError$ = (state: State) => state.sharedPlayer.isError;
export const currentURLByID$ = (state: State) => state.sharedPlayer.currentURLByID;
export const downloadProgressByID$ = (state: State) => state.sharedPlayer.downloadProgressByID;
export const isNeedToPlayAll$ = (state: State) => state.sharedPlayer.isNeedToPlayAll;
export const isPlayingTrack$ = (state: State) => state.sharedPlayer.isPlayingTrack;
